import React, { useState, useEffect } from 'react';
import './App.css'; // Import the CSS file


const Explorer = () => {
  const [breederKeys, setBreederKeys] = useState([]);
  const [selectedBreeder, setSelectedBreeder] = useState(null);
  const [strainKeys, setStrainKeys] = useState([]);
  const [selectedStrain, setSelectedStrain] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [strainDetails, setStrainDetails] = useState(null);
 // const [bbbExists, setBbbExists] = useState(false);
 // var bbb;
  // Fetch initial data for breeders
  useEffect(() => {
    fetch('https://en.seedfinder.eu/api/json/ids.json?br=all&ac=30eb9835d49baf6e460bcf940282125f&output=0')
      .then(response => response.json())
      .then(data => {
        setBreederKeys(Object.entries(data));
      })
      .catch(error => console.error('Error fetching breeder data:', error));
  }, []);

  const handleBreederChange = (event) => {
    const [brid, data] = JSON.parse(event.target.value);

    setSelectedBreeder({ brid, ...data });

    // Fetch strains data and logo
    fetch(`https://en.seedfinder.eu/api/json/ids.json?strains=1&ac=30eb9835d49baf6e460bcf940282125f&br=${brid}`)
      .then(response => response.json())
      .then(data => {
        const logoFilename = data[brid]?.logo;
        setLogoUrl(`https://en.seedfinder.eu/pics/00breeder/${logoFilename}`);

        const strains = data[brid]?.strains || {};
        setStrainKeys(Object.entries(strains));
      })
      .catch(error => console.error('Error fetching strains data:', error));
  };

  const handleStrainChange = (event) => {
    const [strainId, strainData] = JSON.parse(event.target.value);

    setSelectedStrain(strainId);
    console.log("strainData::: ", strainData)


    if (selectedBreeder) {
      const { brid } = selectedBreeder;
      fetch(`https://de.seedfinder.eu/api/json/strain.json?ac=30eb9835d49baf6e460bcf940282125f&output=0&parents=1&hybrids=1&medical=1&comments=10&pics=1&reviews=1&tasting=1&br=${brid}&str=${strainId}`)
        .then(response => response.json())
        .then(data => {
          setStrainDetails(data);
        })
        .catch(error => console.error('Error fetching strain details:', error));
    }
  };

console.log("selectedStrain::: " , selectedStrain)

return (
    <div>
      <h2>Explore by Breeder</h2>

      <div>
        <label htmlFor="breeder-select">Select a Breeder: </label>
        <select id="breeder-select" onChange={handleBreederChange}>
          <option value="">--Choose a breeder--</option>
          {breederKeys.map(([key, data]) => (
            <option key={key} value={JSON.stringify([key, data])}>
              {key}
            </option>
          ))}
        </select>
      </div>

      {logoUrl && (
        <div>
          <img src={logoUrl} alt="Breeder Logo" />
        </div>
      )}

      <div>
        <label htmlFor="strain-select">Select a Strain: </label>
        <select id="strain-select" onChange={handleStrainChange} disabled={!strainKeys.length}>
          <option value="">--Choose a strain--</option>
          {strainKeys.map(([key, data]) => (
            <option key={key} value={JSON.stringify([key, data])}>
              {key}
            </option>
          ))}
        </select>
      </div>

      {strainDetails && (
        <div className="App-info">
          <p>Strain Details</p>
          <article><h4 className="StrainName">{strainDetails.id}</h4></article>
          <p><b>Genetics Company:</b><a href={strainDetails.brinfo.link} target="_blank" rel="noopener noreferrer">{strainDetails.brinfo.id}</a></p>
          <p><b>Breeder Info:</b> {strainDetails.brinfo.description}</p>
          <img src={strainDetails.brinfo.pic} alt="company logo" />
          {/* Display other details as available */}
          <p>{strainDetails.brinfo.flowering.auto}</p>
          <p><b>Flowering Time:</b> {strainDetails.brinfo.flowering.info}</p>
          <p><b>{strainDetails.id}</b> {strainDetails.brinfo.descr}</p>
          <p><b>Parents:</b></p>
          <p> {strainDetails.parents.strains.aaa.id}</p>

        {strainDetails.parents.strains.bbb ? <p>{strainDetails.parents.strains.bbb.id}</p> : null}
        </div>


      )}
    </div>
  );
};

export default Explorer;
